// extracted by mini-css-extract-plugin
module.exports = {"faq-wrapper":"content_faq-wrapper__x8Ia_"};